import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../permission/authentication.service';
import { LogService } from '../util/log.service';

/**
 * Route-őr a CSAK SUPERADMIN-nak szánt nézetekhez (pl. a beosztás-napló).
 *
 * A `requiredPermissions`-alapú {@link RoleGuard} itt nem elég szigorú: a SUPERADMIN
 * jogosultságai más szerepkörökkel közösek (a `master-data` is csak véletlenül egyedi),
 * ezért a döntés a nyers szerepkörön múlik — az {@link AuthenticationService.isSuperAdmin}
 * metódusban, amelyből a menüpont láthatósága is dől.
 */
@Injectable({
  providedIn: 'root'
})
export class SuperAdminGuard {
  constructor(
    private readonly router: Router,
    private readonly authService: AuthenticationService,
    private readonly log: LogService
  ) {}

  canActivate(): boolean {
    if (this.authService.isSuperAdmin()) {
      return true;
    }
    this.log.warn('SuperAdminGuard: the view is SUPERADMIN-only. Access denied.');
    this.router.navigate(['/auth/access'], { queryParams: { needed: 'superadmin' } });
    return false;
  }
}
